import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Chatbot from './components/Chatbot';
import Welcome from './pages/Welcome_new';
import Auth from './pages/Auth';
import Servers from './pages/Servers';
import Widgets from './pages/Widgets';
import Users from './pages/Users';
import AdminDashboard from './pages/AdminDashboard';
import SummaryDashboard from './pages/SummaryDashboard';
import RTSystem from './pages/RTSystem';
import AppSoftware from './pages/AppSoftware';
import { useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SettingsProvider } from './contexts/SettingsContext';

const ProtectedRoute = ({ children, requireAdmin }) => {
  const { user, isAdmin, isActive } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />;
  if (!requireAdmin && !isActive && !isAdmin) return <Navigate to="/" replace />;

  return children;
};

const RedirectIfLoggedIn = ({ children, isWelcomePage }) => {
  const { user, isAdmin, isActive } = useAuth();

  if (user) {
    if (isAdmin) return <Navigate to="/admin" replace />;
    if (isActive) return <Navigate to="/servers" replace />;
    if (isWelcomePage) return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <SettingsProvider>
      <ThemeProvider>
        <Router>
          <div className="app-wrapper">
            <Navbar />
            <main>
              <Routes>
                <Route
                  path="/"
                  element={
                    <RedirectIfLoggedIn isWelcomePage={true}>
                      <Welcome />
                    </RedirectIfLoggedIn>
                  }
                />
                <Route
                  path="/login"
                  element={
                    <RedirectIfLoggedIn isWelcomePage={false}>
                      <Auth />
                    </RedirectIfLoggedIn>
                  }
                />
                <Route
                  path="/servers"
                  element={
                    <ProtectedRoute>
                      <Servers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/summary"
                  element={
                    <ProtectedRoute>
                      <SummaryDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/widgets"
                  element={
                    <ProtectedRoute>
                      <Widgets />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/rt-system"
                  element={
                    <ProtectedRoute>
                      <RTSystem />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/app-software"
                  element={
                    <ProtectedRoute>
                      <AppSoftware />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute requireAdmin={true}>
                      <Users />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requireAdmin={true}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Chatbot />
          </div>
        </Router>
      </ThemeProvider>
    </SettingsProvider>
  );
}

export default App;
